module.exports = __webpack_public_path__ + "img/boxBackArrow.0adc0ccb.svg";